/* @flow */

export const TYPE = {
    FUNCTION:  ('function' : 'function'),
    ERROR:     ('error' : 'error'),
    PROMISE:   ('promise' : 'promise'),
    REGEX:     ('regex' : 'regex'),
    DATE:      ('date' : 'date'),
    ARRAY:     ('array' : 'array'),
    OBJECT:    ('object' : 'object'),
    STRING:    ('string' : 'string'),
    NUMBER:    ('number' : 'number'),
    BOOLEAN:   ('boolean' : 'boolean'),
    NULL:      ('null' : 'null'),
    UNDEFINED: ('undefined' : 'undefined')
};
